import { Box, IconButton, styled } from '@mui/material'
import { WithBodyMessage } from '@weblite/ts-action/message'
import { CloseIcon } from '$common/icons/close'
import { useFullscreenModeOnMediaOpen } from '$comp/_app/components/chat/components/footer/components/send-field/react-hooks'
import { EditText } from './components/edit-text'
import { EditFile } from './components/edit-file'
import { EditImage } from './components/edit-image'
import { EditVideo } from './components/edit-video'
import { useOpenedRoomPermissions } from '$logic/opened-room'
import { t } from '$i18n'

const StyledBox = styled(Box)`
  display: flex;
  /* @noflip */
  padding: 2px 4px 2px 14px;
  background-color: white;
  box-sizing: border-box;
  box-shadow: inset 0 1px 0 rgba(0, 0, 0, 0.1);
  /* @noflip */
  border-radius: 8px 8px 0 0;
  z-index: 1;
  align-items: center;
  gap: 4px;
`

interface Props {
  message: WithBodyMessage
  newFile?: File
  setSelectedFile: (file: File) => unknown
  makeSendFieldFullscreen: () => void
  onCancel: () => void
}

export function Edit({
  message,
  newFile,
  setSelectedFile,
  makeSendFieldFullscreen,
  onCancel,
}: Props) {
  const { body, type } = message

  const { openedRoomPermissions } = useOpenedRoomPermissions()
  const canEditMedia = openedRoomPermissions?.sendMedia

  useFullscreenModeOnMediaOpen(message.type, makeSendFieldFullscreen, onCancel)

  return type === 'IMAGE' ? (
    <EditImage
      newFile={newFile}
      attachment={message.attachment}
      canReplace={canEditMedia}
      onCancel={onCancel}
      setSelectedFile={setSelectedFile}
    />
  ) : type === 'VIDEO' ? (
    <EditVideo
      newFile={newFile}
      attachment={message.attachment}
      canReplace={canEditMedia}
      onCancel={onCancel}
      setSelectedFile={setSelectedFile}
    />
  ) : (
    <StyledBox>
      <IconButton onClick={onCancel}>
        <CloseIcon sx={{ color: 'gray' }} />
      </IconButton>
      {type === 'VOICE' ? (
        <EditText body={t('message.VOICE')} />
      ) : type === 'FILE' || type === 'AUDIO' ? (
        <EditFile
          body={newFile?.name || message.attachment.filename}
          canReplace={canEditMedia}
          setSelectedFile={setSelectedFile}
          messageType={type}
        />
      ) : (
        <EditText body={body as string} />
      )}
    </StyledBox>
  )
}
